import React, { useState } from "react";
import ScreenshotLightbox from "./ScreenshotLightbox";
import { Image as ImageIcon } from "lucide-react";

/**
 * Inline screenshot thumbnails that open a lightbox on click.
 * Props: screenshots (array of {url, fileName, storagePath}), size (px), maxVisible
 */
export default function ScreenshotThumbnail({ screenshots = [], size = 48, maxVisible = 3 }) {
  const [lightboxIndex, setLightboxIndex] = useState(null);

  if (!screenshots || screenshots.length === 0) return null;

  const visible = screenshots.slice(0, maxVisible);
  const remaining = screenshots.length - maxVisible;

  return (
    <>
      <div className="flex items-center gap-1.5">
        {visible.map((img, i) => (
          <button
            key={i}
            onClick={() => setLightboxIndex(i)}
            className="relative rounded-lg overflow-hidden border border-slate-600 hover:border-cyan-400 transition-colors shrink-0"
            style={{ width: size, height: size }}
          >
            <img
              src={img.url}
              alt={img.fileName || `Screenshot ${i + 1}`}
              className="w-full h-full object-cover"
            />
          </button>
        ))}
        {remaining > 0 && (
          <button
            onClick={() => setLightboxIndex(maxVisible - 1)}
            className="rounded-lg border border-slate-600 hover:border-cyan-400 flex items-center justify-center bg-slate-800 text-slate-400 text-xs font-bold transition-colors shrink-0"
            style={{ width: size, height: size }}
          >
            +{remaining}
          </button>
        )}
        <div className="flex items-center gap-1 text-[10px] text-slate-500">
          <ImageIcon size={10} />
          {screenshots.length}
        </div>
      </div>

      {/* Lightbox */}
      {lightboxIndex !== null && (
        <ScreenshotLightbox
          images={screenshots}
          initialIndex={lightboxIndex}
          onClose={() => setLightboxIndex(null)}
        />
      )}
    </>
  );
}
